import { newApiInstance } from 'functions/request';

export const fetchLandingPage = (id, lpTest) => {
  const queryParams = lpTest ? `?lp_test=${lpTest}` : '';

  return newApiInstance.get(`/marketing_pages/${id}${queryParams}`);
};
